import { api } from "../../lib";

export interface InsurancePlanType {
  id: string;
  type: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateInsurancePlanTypeInput {
  type: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateInsurancePlanTypeInput
  extends Partial<CreateInsurancePlanTypeInput> {
  id: string;
}

export const insurancePlanTypesService = {
  getAll: async () => {
    return api.get<InsurancePlanType[]>("/admin/insurance-plan-types");
  },

  getById: async (id: string) => {
    return api.get<InsurancePlanType>(`/admin/insurance-plan-types/${id}`);
  },

  create: async (input: CreateInsurancePlanTypeInput) => {
    return api.post<InsurancePlanType>("/admin/insurance-plan-types", input);
  },

  update: async (input: UpdateInsurancePlanTypeInput) => {
    const { id, ...updates } = input;
    return api.put<InsurancePlanType>(
      `/admin/insurance-plan-types/${id}`,
      updates
    );
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/insurance-plan-types/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<InsurancePlanType>(`/admin/insurance-plan-types/${id}`, {
      isActive,
    });
  },
};
